import { VueMaskDirective } from 'v-mask'
import {VMoney} from 'v-money'

export function addDirectives(Vue){
    Vue.directive('mask', VueMaskDirective);
    Vue.directive('money', VMoney);
}
